import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./router";
import moment from "moment";
import VueGtag from "vue-gtag";

import "./assets/css/style.scss";

window._ = require("lodash");

Vue.config.productionTip = false;
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("kk:mm");
  }
});
Vue.filter("formatDay", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM");
  }
});
export const eventBus = new Vue({
  methods: {
    selectEvent(eventSelected) {
      this.$emit("selectEvent", eventSelected);
    }
  }
});

Vue.use(VueGtag, {
  config: { id: "UA-158835370-1" }
});

new Vue({
  el: "#app",
  router,
  VueRouter,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js